/* eslint-disable @typescript-eslint/no-explicit-any */
import { BaseQueryFn } from '@reduxjs/toolkit/query'
import { AppDispatch } from '../store'

export function getBaseQuery<TError>() {
  const query: BaseQueryFn<Promise<{ data: unknown }>, unknown, TError> = async (args) => {
    return args
      .then((response) => {
        return response
      })
      .catch((e: TError) => {
        return { error: Object.assign({}, e) }
      })
  }

  return query
}

export function wrapQuery<Args extends (object | string | number | boolean | undefined)[], Result>(
  fn: (...args: Args) => (...queryArgs: any[]) => { unwrap: () => Promise<Result>; unsubscribe?: () => void }
) {
  return (...args: Args) =>
    async (dispatch: AppDispatch) => {
      const promise = dispatch(fn(...args))

      try {
        return await promise.unwrap()
      } finally {
        promise.unsubscribe?.()
      }
    }
}
